<template>
  <v-container fluid>
    <h1>{{ get("header-1") }}</h1>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6">
            <v-img :src="safety" class="image"></v-img>
          </v-col>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6">
            <p>
              {{ get("p-1.1") }}
            </p>
            <p>
              {{ get("p-1.2") }}
            </p>
            <p>
              {{ get("p-1.3") }} 
              {{ get("company")}}
              {{ get("p-1.4") }}
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2>
          {{ get("header-2") }}
        </h2>
        <p>
          {{ get("p-2.1") }}
           <phonenumber phone="(303) 778-8010"></phonenumber>
           {{ get("p-2.2") }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
import router from "@/router";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";
export default {
  name: "About-Insurance",

  components: {
    estimate,
    phonenumber,
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  created() {
    this.pageName = "about-insurance";
  },

  data: () => ({
    safety: require("@/assets/safety.jpg"),
  }),

  mixins: [localizationMixin],

  methods: {
    onAbout() {
      router.push("/about/home");
    },
    getLocalization(){}
  },
};
</script>

<style lang="scss" scoped>
</style>
